// globals
const e_root = document.querySelector(':root');

window.addEventListener('load', () => {
  e_root.style.setProperty('--firstViewHeight', `${window.innerHeight}px`);
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})

window.addEventListener('resize', () => {
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})
class Page {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    $(function(){
      //クリックで動く

      $('.js-acc-trigger').click(function(){
        $(this).find('.js-acc-plus').toggleClass('is-open');
        $(this).next('ul').slideToggle();
      });
    });

  }
}
class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    //MVスライダー
    const mvSwiper = new Swiper(".swiper-mv", {
      loop: true,
      effect: 'fade',
      speed: 1000,
      autoplay: { // 自動再生
        delay: 3500, // 1.5秒後に次のスライド
      },
      slidesPerView: "auto"
    });


    if (window.matchMedia('(min-width: 768px)').matches) {
      const html = document.querySelector("html")
      // let lenis = new Lenis();
      // function raf(time) {
      //   lenis.raf(time);
      //   requestAnimationFrame(raf);
      // }

      // requestAnimationFrame(raf);

      // 診療科目　固定アニメーション
      const scrollItems = document.querySelectorAll(".js-scroll-item")
      let percentage


      gsap.to('.js-scroll-item',
      {
        scrollTrigger: {
          trigger: '.js-scrollWrap',
          pin: true, // trigger要素を固定
          // markers:true,
          scrub: 0.8,
          ease:'none',
          start: '-=180',
          end:'+=5100',
          duration: 0.5,
          // onEnter: () => {
          //   let lenis = new Lenis();
          //   function raf(time) {
          //     lenis.raf(time);
          //     requestAnimationFrame(raf);
          //   }

          //   requestAnimationFrame(raf);
          // },

          onUpdate:(self)=>{

            percentage = self.progress.toLocaleString( undefined, { maximumFractionDigits:3 })*100;

            scrollItems.forEach((ele,i) => {
              if( i * 20  <= percentage &&  percentage <= (i + 1) * 20){
                let scrollNum
                scrollNum = percentage / 20
                scrollNum = scrollNum - ((scrollNum > 0) ? Math.floor(scrollNum) : Math.ceil(scrollNum));

                if(scrollNum !== 0){

                  const dataNum = ele.dataset.num
                  if(dataNum == (i + 1)){
                    const nextEle = ele.nextElementSibling
                    const EleTxt = ele.querySelector(".js-scroll-txt")

                    const img = document.querySelector(`.js-change-img-0${i + 2}`)

                    // console.log(Math.round(100 - scrollNum / 10) * 10);

                    if(nextEle){
                      const nextEleTxt = nextEle.querySelector(".js-scroll-txt");
                      const nextEleLine = nextEle.querySelector(".js-scroll-line");
                      const eleLine = ele.querySelector(".js-scroll-line")
                      nextEle.style.opacity = scrollNum + 0.5
                      nextEleTxt.style.opacity = scrollNum
                      nextEleTxt.style.height = `${scrollNum * 20}rem`
                      ele.style.opacity = 1.5 - scrollNum
                      EleTxt.style.opacity = 1 - scrollNum
                      EleTxt.style.height = `${ 20 - scrollNum * 20}rem`

                      // テキスト部分
                      if(Math.round(100 - scrollNum * 100) < 25){

                        nextEleLine.style.width = "100%"
                        eleLine.style.width = 0
                        EleTxt.style.height = 0
                        EleTxt.style.opacity = 0
                        img.style.transform = `translate(0,0)`

                      }else if(75 < Math.round(100 - scrollNum * 100)){
                        eleLine.style.width = "100%"
                        nextEleLine.style.width = 0
                        nextEleTxt.style.opacity = 0
                        nextEleTxt.style.height = 0
                        img.style.transform = `translate(0,100%)`

                      }
                      else{
                        eleLine.style.width = `${100 - scrollNum * 100}%`
                        nextEleLine.style.width = `${scrollNum * 100}%`
                        img.style.transform = `translate(0,${Math.round(100 - scrollNum * 100)}%)`
                      }


                    }else{
                      ele.style.opacity = 1
                      EleTxt.style.opacity = 1
                      EleTxt.style.height = "16rem"
                    }
                  }
                }
              }
            });
            },
        },

      });

    }

    if (window.matchMedia('(max-width: 767px)').matches) {
      const reserveBtn = document.querySelector(".p-top__reserve")
      const reserveLine = document.querySelector(".js-reserve-line").getBoundingClientRect().top

      window.addEventListener("scroll", () => {
        var scroll_y = window.scrollY;
        if(reserveLine < scroll_y){
          reserveBtn.classList.add("is-hidden")
        }else{
          reserveBtn.classList.remove("is-hidden")
        }
      })

    }
    const breakpoint = window.matchMedia("(max-width:767px)");

    breakpoint.addEventListener("change", () => {
      window.location.reload();
    });

  }
}
var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $("." + this.el).parent().parent().parent().next().addClass('c-accordion__inner').css({'display': 'none'});
    $("." + this.el).parent().parent().parent().parent().addClass('c-accordion__wrap')

    $("." + this.el).on('click', function() {
      $(this).toggleClass('is-active');
      $(this).parent().parent().parent().next().slideToggle();
    })
  }
}
class Calendar {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-tab-trigger li:first-child').addClass('active');
    $(".js-tab-inner ul:first-of-type").css("display", "block");
    let date = new Date();

    $('.js-change-date').html(`${date.getFullYear()}年 ${date.getMonth() + 1}月`)

    let swiper = new Swiper(".calendarSwiper", {
      initialSlide: $(`[data-year="${date.getFullYear()}"][data-month="${date.getMonth() + 1}"]`).index(),
      navigation: {
        nextEl: ".next-btn",
        prevEl: ".prev-btn",
      },
      threshold: 999999,
      spaceBetween: 20,
      speed: 500,
    });

    swiper.on('slideChangeTransitionStart', function () {
      $('.js-change-date').html($('.swiper-slide-active').data('date'));
    });
  }
}
class Editor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-editor p, .c-editor div').each(function(index, el) {
      if(el.textContent == ' ' || el.textContent == '') {
        el.style.height = '1px';
        el.style.marginTop = '1.5rem';
      }
    })
  }
}
class FooterCalendar {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    // let date = new Date();

    // $('.js-change-date').html(`${date.getFullYear()}年 ${date.getMonth() + 1}月`)

    // let swiper = new Swiper(".mySwiper", {
    //   initialSlide: $(`[data-year="${date.getFullYear()}"][data-month="${date.getMonth() + 1}"]`).index(),
    //   navigation: {
    //     nextEl: ".next-btn",
    //     prevEl: ".prev-btn",
    //   },
    //   spaceBetween: 50,
    //   speed: 500,
    // });
  }
}

class Loading {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const body = document.getElementsByTagName('body')[0];
    const btn = document.getElementById('btn');
    let scrollTop = 0;
    
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('no_scroll');
    
    setTimeout(() => {
      $(".c-loading").fadeOut(500);
      body.style.top = '';
      body.classList.remove('no_scroll');
      window.scrollTo(0, scrollTop);
    }, 800);
  }
}
class Modal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-modal-inner').parent().clone().insertBefore('.c-modal .c-modal-clone');

    $('main .c-modal-inner').parent().remove();

    const body = document.getElementsByTagName('body')[0];
    let scrollTop = 0;

    $(".c-modal-inner").parent().addClass('u-mt-0');

    $(".c-modal-trigger").on("click", function() {
      $(`#${$(this).data('id')}, .c-modal-overlay`).addClass('is-active');

      scrollTop = window.scrollY;
      body.style.top = (scrollTop * -1) + 'px';
      body.classList.add('no_scroll');

      return false;
    })

    $(".c-modal-close, .c-modal-overlay").on("click", function() {
      $(`.c-modal-inner, .c-modal-overlay`).removeClass('is-active');
      body.style.top = '';
      body.classList.remove('no_scroll');
      window.scrollTo(0, scrollTop);
    })
  }
}
class Slider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.c-swiper', {
      speed: 500,
      loop: true,
      autoplay: {
        delay: 5000,  
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    })
  }
}

class Tab {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-tab-trigger').parent().parent().parent().addClass('u-mb-0');
    $(".c-tab-inner").parent().addClass('c-tab-wrap');
    $(".c-tab-wrap").eq(0).css({'display': 'block'});

    $(".c-tab-trigger li").on('click', function() {
      let el_num = $(this).index();
      $(".c-tab-trigger li").removeClass('is-active');
      $(this).addClass('is-active');

      $('.c-tab-wrap').css({'display': 'none'});
      $('.c-tab-wrap').eq(el_num).css({'display': 'block'});
    })
  }
}
//noScroll
class Common {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // let elFs;

    // $('.c-content *').each(function() {

    //   let css = ['font-size', 'padding-left', 'padding-top', 'padding-right', 'padding-bottom', 'margin-left', 'margin-top', 'margin-right', 'margin-bottom']
    //   let this_el = $(this);

    //   css.forEach(el => {
    //     elFs = this_el.css(el);
    //     if(elFs.match(/([0-9]*)\.[0-9]*(px)/)) {
    //       elFs = elFs.replace(/([0-9]*)\.[0-9]*(px)/, '$1$2');
    //     }
    //     elFs = elFs.replace(/([0-9])px/, '.$1rem');
    //     this_el.css(el, elFs);
    //   });

    //   // height
    //   if($(this).prop('nodeName').match(/TABLE|TD|TR|TBODY/)) {
    //     elFs = $(this).css('height');
    //     if(elFs.match(/([0-9]*)\.[0-9]*(px)/)) {
    //       elFs = elFs.replace(/([0-9]*)\.[0-9]*(px)/, '$1$2');
    //     }
    //     elFs = elFs.replace(/([0-9])px/, '.$1rem');
    //     $(this).css('height', elFs);
    //   }
    // })

    // $('.c-content p').each(function() {
    //   if($(this)[0].innerHTML == '&nbsp;') {
    //     $(this)[0].innerHTML = '';
    //   }
    // });
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

var cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class HeaderEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const menuOpenTrigger = document.querySelector(".js-header-mega")
    const menuOpenContent = document.querySelector(".js-header__modal")
    const menuPlusIcon = document.querySelectorAll(".js-mega-plus")

    menuOpenTrigger.addEventListener("mouseover", () => {
      menuOpenContent.classList.add("is-active")
      menuPlusIcon.forEach(ele => {
        ele.classList.add("is-active")
      });

    })
    menuOpenTrigger.addEventListener("mouseleave", () => {
      menuOpenContent.classList.remove("is-active")
      menuPlusIcon.forEach(ele => {
        ele.classList.remove("is-active")
      });
    })


    const headerContainer = document.querySelector(".js-header")
    window.addEventListener('scroll', function(){
      if(1 <= window.scrollY){
        headerContainer.classList.add("is-scroll")
      }else{
        headerContainer.classList.remove("is-scroll")
      }
    });

    if (window.matchMedia('(max-width: 767px)').matches) {
      $('.ham-trigger-is-appear').click(function(){
        if($(this).text() == '＋開く'){
          $(this).text('×');
        }else{
          $(this).text('＋開く');
        }
        $(this).next('.is-appear').slideToggle();
      }
      );

      const headerTrigger = document.querySelector(".js-header-hamMenu")
      const menuContainer = document.querySelector(".ham-menu")
      const menuLink = document.querySelectorAll(".ham-menu a[href*='#']")

      headerTrigger.addEventListener("click", () => {
        if(!headerContainer.classList.contains("is-scroll")){
          headerContainer.classList.add("is-scroll")
        }

        menuContainer.classList.toggle("is-active")
        headerTrigger.classList.toggle("is-active")
        headerContainer.classList.toggle("is-active")

        scrollBan();

      })

      menuLink.forEach((el) => {
        el.addEventListener('click', (e) => {
          let href = e.target.getAttribute('href');
          href = href.split('#')[1];
          if(document.querySelector(`#${href}`)) {
            menuContainer.classList.toggle("is-active")
            headerTrigger.classList.toggle("is-active")
            headerContainer.classList.toggle("is-active")
            
            scrollBan();
          }
        })
      })
    }


    // スムーススクロール

    // // 固定ヘッダーの高さ（＋追加したい余白）
    // var headerHeight = jQuery('js-header').outerHeight() + 120;

    // // ページ内のアンカーへスクロール
    // jQuery('a[href*="#"]').click(function () {
    //   var target = jQuery(this.hash === '' ? 'html' : this.hash);
    //   var position = target.offset().top - headerHeight;
    //   if (target.length) {
    //     jQuery('html, body').animate({scrollTop:position}, 500, 'swing');

    //     // #タグをURLに残す場合は削除
    //     return false;
    //   }
    // });

    // // ページ外のアンカーへスクロール
    // var urlHash = location.hash;
    // // console.log(urlHash);
    // if(urlHash) {
    //   var target = jQuery(urlHash);
    //   var position = target.offset().top - headerHeight;
    //   // どこからスクロールさせるか ※一番上ならscrollTop(0)
    //   jQuery('body,html').stop().scrollTop(position - 200);
    //   setTimeout(function(){
    //     jQuery('body,html').stop().animate({scrollTop:position}, 500, 'swing');
    //   }, 100);
    // }

  }
}
//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        console.log(entry.intersectionRatio);
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        console.log(entry.intersectionRatio);
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}


(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');

});


//after loading animation
$(window).on('loading', () => {
  let common = new Common('c-content');
  let imgParallax = new ImgParallax('js-parallax');
  let top = new Top('p-top');
  let page = new Page('p-page');
  let headerEvent = new HeaderEvent('js-header');
  let footerCalendar = new FooterCalendar();
  let calendar = new Calendar('calendarSwiper');
  


  // 以下ページビルダー用
  let accordion = new Accordion('c-accordion');
  let modal = new Modal('c-modal-trigger');
  let tab = new Tab('c-tab-trigger');
  let swiper = new Slider('c-swiper');
  let loading = new Loading('c-loading');
  let editor = new Editor('c-editor');
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });